module.exports = __webpack_public_path__ + "static/media/trial2_2.6369f771.png";